import { render, staticRenderFns } from "./EditPromoCode.vue?vue&type=template&id=58434112"
import script from "./EditPromoCode.vue?vue&type=script&lang=ts"
export * from "./EditPromoCode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports